import { FileDownloadIcon, TablePager } from '@fukuri-admins/ui/common';
import { ActionButton } from '~/components/common/ActionButton';
import { ContentsHeader } from '~/components/common/ContentsHeader';
import { ServiceReportTableContent } from '~/components/ServiceReport/ServiceReportTableContent';
import Shimmer from '~/components/Shimmer';
import styles from '../styles.module.scss';

type ServiceReportTableContentProps = React.ComponentProps<typeof ServiceReportTableContent>;
type TablePagerProps = React.ComponentProps<typeof TablePager>;
type Props = {
  loading: boolean;
  currentPage: TablePagerProps['currentPage'];
  filteredServiceApplications: ServiceReportTableContentProps['rows'];
  totalPage: TablePagerProps['totalPage'];
  totalCount: TablePagerProps['totalCount'];
  handleOutputCsv: () => Promise<void>;
  handleHeaderSort: ServiceReportTableContentProps['onSort'];
  handlePageChange: TablePagerProps['onPageChange'];
};

export const ServiceReportPresentation: React.FC<Props> = ({
  loading,
  currentPage,
  filteredServiceApplications,
  totalPage,
  totalCount,
  handleOutputCsv,
  handlePageChange,
  handleHeaderSort,
}) => {
  return (
    <div className={styles.Root}>
      <div className={styles.container}>
        <ContentsHeader
          title='サービス利用履歴'
          description='以下より、サービス利用履歴を確認できます。'
          actions={
            <ActionButton
              content='CSV出力'
              type='darkFill'
              icon={<FileDownloadIcon />}
              iconPosition='left'
              action={handleOutputCsv}
            />
          }
        />
        {loading ? (
          <Shimmer />
        ) : (
          <div className={styles.Root__Table}>
            <div className={styles.tableWrapper}>
              <ServiceReportTableContent
                rows={filteredServiceApplications}
                onSort={handleHeaderSort}
              />
            </div>
            <TablePager
              currentPage={currentPage}
              totalPage={totalPage}
              totalCount={totalCount}
              onPageChange={handlePageChange}
              itemCount={filteredServiceApplications.length}
            />
          </div>
        )}
      </div>
    </div>
  );
};
